import { AppModules } from 'appContainer/types';
import { Features } from '@ardoq/features';
import {
  IndexRouteContent,
  LayoutRouteContent,
  PathRouteContent,
  RouteNode,
} from 'router/declarative/routeNode';
import { adminBoundary } from 'router/declarative/adminBoundary';
import { composeBoundaries } from 'router/declarative/composeBoundaries';
import { featureFlagBoundary } from 'router/declarative/featureFlagBoundary';

export const routes = {
  path: '/broadcasts',
  title: 'Broadcasts',
  appModule: AppModules.BROADCASTS,
  content: composeBoundaries([
    featureFlagBoundary([Features.BROADCASTS], {
      pageName: 'Broadcasts',
    }),
    adminBoundary(),
  ]),
  children: [
    {
      path: { layout: true },
      content: async (): LayoutRouteContent =>
        (await import('../BroadcastLayout')).BroadcastsLayout,
      children: [
        {
          path: { index: true },
          content: async (): IndexRouteContent =>
            (await import('../broadcastOverview/BroadcastOverview'))
              .BroadcastOverview,
        },
        {
          path: '/new',
          content: async (): PathRouteContent =>
            (await import('../broadcastCreator/BroadcastCreator'))
              .BroadcastCreator,
        },
        {
          path: '/:entityId',
          content: async (): PathRouteContent =>
            (await import('../broadcastEditor/BroadcastEditor'))
              .BroadcastEditor,
        },
      ],
    },
  ],
} as const satisfies RouteNode;
